export type { EquipmentsPageProps } from "./equipments-page";
export { EquipmentsPage } from "./equipments-page";
